import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { TeamspaceSettingsModal } from '@/widgets/teamspaceSettings';

import { BuyMinutesModal } from '@/features/pricing/buyMinutes';
import { UpgradeConfirmationModal } from '@/features/pricing/upgradeConfirmation';
import { TeamspaceWelcomeModal, useIsSpaceOwner } from '@/features/teamspace';

import { EnterprisePaymentRequiredModal, UpgradePlanModal } from '@/entities/pricing';

import { useHandlePaymentSuccess } from './hooks/useHandlePaymentSuccess';

export const BaseLayout = () => {
  const isSpaceOwner = useIsSpaceOwner();

  useHandlePaymentSuccess();

  return (
    <Suspense>
      <Outlet />
      <UpgradePlanModal isSpaceOwner={isSpaceOwner} />
      <UpgradeConfirmationModal />
      <EnterprisePaymentRequiredModal />
      <BuyMinutesModal />
      <TeamspaceSettingsModal />
      <TeamspaceWelcomeModal />
    </Suspense>
  );
};
